import { classNames } from "@gettactic/helpers/src/css/classNames";
import React from "react";

export interface LabelProps extends React.HTMLAttributes<HTMLLabelElement> {
  /**
   * Is label for a checkbox? Applies checkbox styling.
   */
  check?: boolean;
  /**
   * Is label for a radio button? Applies radio button styling.
   */
  radio?: boolean;
  /**
   * Explicity "for" attribute to tie a label to input
   */
  htmlFor?: string;
  /**
   * Is label disabled? Applies disabled styling.
   */
  disabled?: boolean;
  /**
   * Additional class names. Applied to <label>.
   */
  className?: string;
  /**
   * Optional children. Typically text for text input.
   */
  children?: React.ReactNode;
}

const styles = Object.freeze({
  base: "block text-secondary-foreground",
  checkbox: "inline-flex items-center",
  radio: "inline-flex items-center",
  disabled: "opacity-50 cursor-not-allowed"
});

/**
 * Legacy label of the first design system, with checkbox and radio layouts.
 * @deprecated Use `Label` from `primitives/label`.
 */
export const Label: React.FC<LabelProps> = ({
  children,
  check,
  radio,
  disabled,
  htmlFor,
  className
}) => {
  const cls = classNames(
    styles.base,
    check ? styles.checkbox : "",
    radio ? styles.radio : "",
    disabled ? styles.disabled : "",
    className ? className : ""
  );

  return (
    <label className={cls} htmlFor={htmlFor}>
      {children}
    </label>
  );
};
